import Create from './CreateKey';

export default Create;
